/**
 * 86bcd9hgt: the properties-usage bar on the Billing page. Pure so it can be unit-tested
 * on its own and reused by PropertiesUsageCard.
 *
 * `count` is the landlord's countable property count; `max` is the current tier's upper
 * bound (null/0 means the top tier, which has no ceiling).
 */

/**
 * Fill percent (0–100) for the usage bar. The top tier (no max) reads full once it has
 * any property, and empty otherwise.
 */
export function usagePercent(count, max) {
    const safeCount = Number(count) || 0;

    if (!max || max <= 0) {
        return safeCount > 0 ? 100 : 0;
    }

    const pct = Math.round((safeCount / max) * 100);

    return Math.max(0, Math.min(100, pct));
}

/**
 * How many more properties fit before the next tier starts. Returns null on the top tier
 * (no next tier to cross).
 */
export function propertiesUntilNextTier(count, max) {
    if (!max || max <= 0) {
        return null;
    }

    return Math.max(0, max - (Number(count) || 0));
}
